import axios from 'axios';
import clientAxios from '../../configs/axios';

const API_URL = process.env.REACT_APP_API_URL;

export function getTotalTickets() {
  return async (dispatch) => {
    dispatch(nivelServiceInit());
    try {
      const response = await axios.post(`${API_URL}/ms-tickets/tickets/dashboard/generales/ticket`);
      let { data } = response.data;
      data = [
        { nameTicket: 'Total General', colorTicket: '#999693', totalTicket: data?.ticketsTotales },
        { nameTicket: 'Abiertos', colorTicket: '#0f83c9', totalTicket: data?.ticketsAbiertos },
        { nameTicket: 'En Curso', colorTicket: '#ffa640', totalTicket: data?.ticketsEnProceso },
        { nameTicket: 'Resueltos', colorTicket: '#27a027', totalTicket: data?.ticketsCerrados },
      ];
      dispatch(nivelServiceSuccess(data));
    } catch (error) {
      dispatch(nivelServiceError(error));
    }
  };
}

export function getGraphicTickets() {
  return async (dispatch) => {
    dispatch(nivelTicketInit());
    try {
      const response = await axios.get('/nivelservicio/dataticket/');
      const data = await response.data;
      dispatch(graphicTicketsSuccess(data));
    } catch (error) {
      dispatch(graphicTicketsError(error));
    }
  };
}

export function getGraphicPerWeekTickets() {
  return async (dispatch) => {
    dispatch(nivelTicketWeekInit());
    try {
      // const response = await axios.get('/tablero/datatotal/');
      const response = await axios.post(`${API_URL}/ms-tickets/tickets/porcentaje/dia/status`);
      const data = await response.data.data;
      const formattedData = [
        {
          nameTotal: '1-5 días',
          dataTotal: [
            { x: 'Abiertos', y: data['5Abiertos'], start: 1, end: 5 }, // ABIERTOS
            { x: 'En Curso', y: data['5Proceso'], start: 1, end: 5 }, // PROCESO
            { x: 'Resueltos', y: data['5Cerrados'], start: 1, end: 5 }, // RESUELTO
          ],
        },
        {
          nameTotal: '6-10 días',
          dataTotal: [
            { x: 'Abiertos', y: data['10Abiertos'], start: 6, end: 10 }, // ABIERTOS
            { x: 'En Curso', y: data['10Proceso'], start: 6, end: 10 }, // PROCESO
            { x: 'Resueltos', y: data['10Cerrados'], start: 6, end: 10 }, // RESUELTO
          ],
        },
        {
          nameTotal: '11-15 días',
          dataTotal: [
            { x: 'Abiertos', y: data['15Abiertos'], start: 11, end: 15 }, // ABIERTOS
            { x: 'En Curso', y: data['15Proceso'], start: 11, end: 15 }, // PROCESO
            { x: 'Resueltos', y: data['15Cerrados'], start: 11, end: 15 }, // RESUELTO
          ],
        },
        {
          nameTotal: '15-30 días',
          dataTotal: [
            { x: 'Abiertos', y: data['30Abiertos'], start: 16, end: 30 }, // ABIERTOS
            { x: 'En Curso', y: data['30Proceso'], start: 16, end: 30 }, // PROCESO
            { x: 'Resueltos', y: data['30Cerrados'], start: 16, end: 30 }, // RESUELTO
          ],
        },
        {
          nameTotal: 'Más de 30 días',
          dataTotal: [
            { x: 'Abiertos', y: data.Abiertos, start: 31, end: 1000 }, // ABIERTOS
            { x: 'En Curso', y: data.Proceso, start: 31, end: 1000 }, // PROCESO
            { x: 'Resueltos', y: data.Cerrados, start: 31, end: 1000 }, // RESUELTO
          ],
        },
      ];
      dispatch(graphicPerWeekTicketsSuccess(formattedData));
    } catch (error) {
      dispatch(graphicPerWeekTicketsError(error));
    }
  };
}

export function getTickets(durationIni, durationFin, status) {
  return async (dispatch) => {
    dispatch(nivelGetTicketsInit());
    try {
      const response = await axios.post(`${API_URL}/ms-tickets/tickets/dashboard/detalle/ticket`, {
        durationFin: durationFin || 0,
        durationIni: durationIni || 0,
        ticketStatus: status,
      });
      const { data } = response.data;
      dispatch(nivelGetTicketsSuccess(data || []));
    } catch (error) {
      dispatch(nivelGetTicketsError(error));
    }
  };
}

export function openTicketModal(value) {
  return async (dispatch) => {
    dispatch(nivelOpenModalInit());
    try {
      dispatch(nivelOpenModalSuccess(!value));
    } catch (error) {
      dispatch(nivelOpenModalError(error));
    }
  };
}

export function setStatsFiltersSelected(filtersAdded) {
  return async (dispatch) => {
    dispatch(nivelServiceSetStatsFiltersInit());
    try {
      if (!filtersAdded) {
        dispatch(nivelServiceSetStatsFiltersSuccess({}));
      } else {
        let filters = { ...filtersAdded };
        if ('tiempo' in filtersAdded) {
          filters = { ...filters, ...filtersAdded.tiempo };
          delete filters.tiempo;
        }
        dispatch(nivelServiceSetStatsFiltersSuccess(filters));
      }
    } catch (error) {
      dispatch(nivelServiceSetStatsFiltersError());
    }
  };
}

const nivelServiceInit = () => ({ type: 'VIEW_TICKET_INIT' });
const nivelServiceError = (error) => ({ type: 'VIEW_TICKET_ERROR', payload: error });
const nivelServiceSuccess = (data) => ({ type: 'VIEW_TICKET_SUCCESS', payload: data });
const nivelTicketInit = () => ({ type: 'VIEW_TICKET_DATA_INIT' });
const graphicTicketsError = (error) => ({ type: 'VIEW_TICKET_GRAPHIC_ERROR', payload: error });
const graphicTicketsSuccess = (data) => ({ type: 'VIEW_TICKET_GRAPHIC_SUCCESS', payload: data });
const nivelTicketWeekInit = () => ({ type: 'VIEW_TICKET_WEEK_INIT' });
const graphicPerWeekTicketsError = (error) => ({ type: 'VIEW_TICKET_WEEK_ERROR', payload: error });
const graphicPerWeekTicketsSuccess = (data) => ({ type: 'VIEW_TICKET_WEEK_SUCCESS', payload: data });

const nivelGetTicketsInit = () => ({ type: 'VIEW_GET_TICKETS_INIT' });
const nivelGetTicketsError = (error) => ({ type: 'VIEW_GET_TICKETS_ERROR', payload: error });
const nivelGetTicketsSuccess = (data) => ({ type: 'VIEW_GET_TICKETS_SUCCESS', payload: data });

const nivelOpenModalInit = () => ({ type: 'VIEW_OPEN_MODAL_INIT' });
const nivelOpenModalError = (error) => ({ type: 'VIEW_OPEN_MODAL_ERROR', payload: error });
const nivelOpenModalSuccess = (data) => ({ type: 'VIEW_OPEN_MODAL_SUCCESS', payload: data });

const nivelServiceSetStatsFiltersInit = () => ({ type: 'SET_STATS_FILTERS' });
const nivelServiceSetStatsFiltersSuccess = (data) => ({ type: 'SET_STATS_FILTERS_SUCCESS', payload: data });
const nivelServiceSetStatsFiltersError = (error) => ({ type: 'SET_STATS_FILTERS_ERROR', payload: error });

const initialState = {
  name: 'nivelService ',
  state: false,
  loading: false,
  loadingTicket: false,
  loadingTicketWeek: false,
  totalTickets: [{}],
  graphicTickets: [{}],
  graphicPerWeekTickets: [{}],
  ticketModal: {
    open: false,
    loading: false,
    tickets: [],
  },
  administration: {
    filtersSelected: {},
  },
  stats: {
    filtersSelected: {},
  },
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'VIEW_TICKET_INIT':
      return {
        ...state,
        state: false,
        loading: true,
        loadingTicket: false,
        loadingTicketWeek: false,
      };
    case 'VIEW_TICKET_DATA_INIT':
      return {
        ...state,
        state: false,
        loading: false,
        loadingTicket: true,
        loadingTicketWeek: false,
      };
    case 'VIEW_TICKET_WEEK_INIT':
      return {
        ...state,
        state: false,
        loading: false,
        loadingTicket: false,
        loadingTicketWeek: true,
      };
    case 'VIEW_GET_TICKETS_INIT':
      return {
        ...state,
        ticketModal: {
          ...state.ticketModal,
          loading: true,
        },
      };
    case 'VIEW_TICKET_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        totalTickets: action.payload,
      };
    case 'VIEW_OPEN_MODAL_SUCCESS':
      return {
        ...state,
        ticketModal: {
          ...state.ticketModal,
          open: action.payload,
        },
      };
    case 'SET_STATS_FILTERS_SUCCESS':
      return {
        ...state,
        stats: {
          ...state.stats,
          filtersSelected: action.payload,
        },
      };
    case 'VIEW_TICKET_ERROR':
      return {
        ...state,
        state: true,
        loading: false,
        error: action.payload,
      };
    case 'VIEW_TICKET_GRAPHIC_SUCCESS':
      return {
        ...state,
        state: true,
        loadingTicket: false,
        graphicTickets: action.payload,
      };
    case 'VIEW_GET_TICKETS_SUCCESS':
      return {
        ...state,
        ticketModal: {
          ...state.ticketModal,
          loading: false,
          tickets: action.payload,
        },
      };
    case 'VIEW_TICKET_GRAPHIC_ERROR':
      return {
        ...state,
        state: true,
        loadingTicket: false,
        error: action.payload,
      };
    case 'VIEW_TICKET_WEEK_SUCCESS':
      return {
        ...state,
        state: true,
        loadingTicketWeek: false,
        graphicPerWeekTickets: action.payload,
      };
    case 'VIEW_TICKET_WEEK_ERROR':
      return {
        ...state,
        state: true,
        loadingTicketWeek: false,
        error: action.payload,
      };
    case 'VIEW_GET_TICKETS_ERROR':
      return {
        ...state,
        ticketModal: {
          ...state.ticketModal,
          loading: false,
          tickets: [],
        },
      };
    default:
      return {
        ...state,
      };
  }
}
